export const errorTranslations = {
	modal: {
		fallbackTitle: {
			sv: "Något gick fel",
		},
		fallbackBody: {
			sv: "Var god försök igen lite senare.",
		},
		close: {
			sv: "Stäng",
		},
		networkError: {
			heading: { sv: "Något gick fel" },
			body: { sv: "Var god försök igen lite senare." },
		},
		bankIdUserCancel: {
			heading: { sv: "Du har avbruit signeringen" },
			body: { sv: "Var god försök igen" },
		},
		bankIdCancel: {
			heading: { sv: "Åtgärden avbruten" },
			body: { sv: "Var god försök igen" },
		},
		bankIdTimeout: {
			heading: { sv: "BankID-appen svarar inte" },
			body: {
				sv: "Kontrollera att BankID-appen är startad och att du har internetanslutning. Om du inte har något giltigt BankID kan du hämta ett hos din bank.",
			},
		},
		loggedOut: {
			heading: { sv: "Utloggad" },
			body: {
				sv: "Du har blivit utloggad",
			},
		},
		revisionConflict: {
			body: {
				sv: "Du har en gammal revision av ansökan. Vänligen ladda om sidan för att lösa problemet.",
			},
			title: {
				sv: "Revisionskonflikt",
			},
			close: {
				sv: "Stäng",
			},
			logout: {
				sv: "Logga ut",
			},
			reload: {
				sv: "Ladda om sidan",
			},
		},
		openLockedStep: {
			title: {
				sv: "Vill du verkligen gå tillbaka?",
			},
			body: {
				sv: "Går du tillbaka och gör ändringar kommer signerade avtal behöva signeras på nytt.",
			},
			continue: {
				sv: "Ja, gå tillbaka",
			},
			abort: {
				sv: "Stanna kvar",
			},
		},
		missingBeneficialOwner: {
			title: {
				sv: "Du behöver registrera verklig huvudman",
			},
			body: {
				sv: "Registrera verklig huvudman hos Bolagsverket och försök igen om några dagar. Kvarstår problemet, kontakta kundtjänst på 08-616 99 00.",
			},
		},
	},
};
